import axios from 'axios'


if (process.env.VUE_APP_BASE_API != '/api') {
    axios.defaults.baseURL = process.env.VUE_APP_BASE_API
} else {
    axios.defaults.baseURL = 'http://localhost:8086/api/';
}
axios.defaults.withCredentials = true;
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';
//axios  request拦截器

//axios response 拦截器

//get方法的封装
function getPackage(url,params={}) {
    return new Promise((resolve, reject) => {
        axios.get(url,{
            params:params,
            data:params
        }).then(res=>{
            resolve(res.data)
        }).catch(err=>{
            reject(err)
            console.log(err)
        })
    })
}
//post方法的封装
function postPackage(url, data = {}, config) {
    return new Promise((resolve, reject) => {
        axios.post(url, data, config).then(res => {
            resolve(res.data);
        }).catch(err=>{
            reject(err)
        })
    })
}

//delete方法的封装
function deletePackage(url,params,data={},config) {
    return new Promise((resolve, reject) => {
        axios.delete(url+'/'+params,data,config).then(res=>{
            resolve(res.data)
        }).catch(err=>{
            reject(err)
            console.log(err)
        })
    })
}

//put方法的封装
function putPackage(url,params,data={},config) {
    return new Promise((resolve, reject) => {
        axios.put(url + '/' + params,data,config).then(res=>{
            resolve(res.data)
        }).catch(err=>{
            reject(err)
        })
    })
}
export {
    getPackage,
    postPackage,
    deletePackage,
    putPackage
}

/*
export default  function request(option){
    return new Promise((resolve,reject)=>{
        const instance = axios.create({
            baseURL: 'http://test.open.guoranbot.com:8099/',
            timeout: 5000
        });
        instance(option).then(res => {
            resolve(res)
        }).catch(err => {
            reject(err)
        })
    })
}*/
